export default __webpack_public_path__ + "static/6-85095da928a2d07665018d5fbc6992cd.jpg";